<script setup>
import { ref } from "vue";
import axios from 'axios';
import { urlMainAPI, showError, defaultSuccess } from "@/global";
import SaveButtons from '../commons/SaveButtons.vue';
import CustomInput from '../commons/CustomInput.vue';
import CustomLoading from "../commons/CustomLoading.vue";
import Tree from "liquor-tree";
import VueGridLayout from 'vue-grid-layout';
import MediatorIndicatorEditor from '../MediatorIndicatorEditor';
</script>
<template>
    <section>
        <CustomLoading v-if="this.loadingSteps.status == true" :msg="this.loadingSteps.msg" />
        <section v-show="this.loadingSteps.status == false" class="general-configs-container">
            <b-tabs align="center" end lazy pills no-nav-style class="tabs-container">
                <b-tab active class="tree-container" :title="$t('treeView')">
                    <section class="tree-view-container">
                        <section class="indicator-list-content">
                            <section class="new-roots-btn">
                                <button @click="() => this.$bvModal.show('newScreenModal')">{{ $t('add-new-screen')
                                    }}</button>
                                <button @click="() => this.$bvModal.show('newAreaModal')">{{ $t('add-new-area')
                                    }}</button>
                            </section>
                            <section v-if="isCreating" class="new-indicator-inputs">
                                <span class="tip"><strong>*</strong> {{ $t('fill-fields-to-drag') }}</span>
                                <section>
                                    <CustomInput id="newIndicatorName" type="text"
                                        :title="$t('nome-do-indicador') + ':'"
                                        :modelRef="this.newIndicator.indicatorName"
                                        :inputFunc="event => this.newIndicator.indicatorName = event.target.value"
                                        :optList="[]" optValue="" optDisplay=""
                                        :class="blockNewInput == true ? 'blockInput' : ''" />
                                    <section>
                                        <CustomInput id="newIndicatorType" type="select"
                                            :title="$t('tipo-do-indicador') + ':'"
                                            :modelRef="this.newIndicator.calcType" :inputFunc="event => {
                                                this.newIndicator.calcType = event.target.value
                                                if (event.target.value == 'Root') MediatorIndicatorEditor.isCreatingRoot = true
                                                else MediatorIndicatorEditor.isCreatingRoot = false
                                            }"
                                            :optList="[{ name: $t('online') }, { name: $t('analitico') }, { name: $t('sazonal') }, { name: $t('diario') }, { name: 'Root' }]"
                                            optValue="name" optDisplay="name"
                                            :class="blockNewInput == true ? 'blockInput' : ''" />

                                        <CustomInput id="newIndicatorUnit" type="text" :title="$t('unit')"
                                            :modelRef="this.newIndicator.unit"
                                            :inputFunc="event => this.newIndicator.unit = event.target.value"
                                            :optList="[]" optValue="" optDisplay=""
                                            :class="blockNewInput == true ? 'blockInput' : ''" />
                                    </section>
                                </section>
                                <p class="new-indicator-tip">{{ $t('drag-position-tree') }}</p>
                                <section
                                    :class="(this.newIndicator.indicatorName.trim() != '' && this.newIndicator.calcType.trim() != '' && this.newIndicator.unit.trim() != '') ? 'new-indicator-draggable' : 'new-indicator-draggable draggable-unactive'"
                                    :draggable="this.newIndicator.indicatorName.trim() != '' && this.newIndicator.calcType.trim() != '' && this.newIndicator.unit.trim() != ''"
                                    @dragstart="startDrag($event, newIndicator)">
                                    <section class="new-indicator-circle"></section>
                                    <span>{{ this.newIndicator.indicatorName == '' ? $t('nome-do-indicador') :
                                        this.newIndicator.indicatorName }}</span>
                                    <b-icon-arrows-move class="new-indicator-icon"></b-icon-arrows-move>
                                    <section class="seeNewInd" draggable="false">
                                        <b-icon-eye-slash-fill v-if="treeSearchName == newIndicator.indicatorName"
                                            :alt="$t('seeOnScreen')" :title="$t('seeOnScreen')"
                                            @click="showOnTree('')" />
                                        <b-icon-eye-fill v-else :alt="$t('seeOnScreen')" :title="$t('seeOnScreen')"
                                            @click="showOnTree(newIndicator.indicatorName)" />
                                    </section>
                                </section>
                            </section>
                            <section v-else class="indicator-list">
                                <input type="text" v-model="indSearchName" id="filterList"
                                    :placeholder="$t('indicator-filter')">
                                <section class="listed-indicators">
                                    <section class="indicator" v-for="(ind, idx) in filterList()" :key="idx" draggable
                                        @dragstart="startDrag($event, ind)">
                                        <span>{{ ind.indicatorName }}</span>
                                        <section class="ind-btn">
                                            <b-icon-pencil-fill :alt="$t('edit')" :title="$t('edit')"
                                                @click="indicatorToEdit(ind)" />
                                            <b-icon-eye-slash-fill v-if="treeSearchName == ind.indicatorName"
                                                :alt="$t('seeOnScreen')" :title="$t('seeOnScreen')"
                                                @click="showOnTree('')" />
                                            <b-icon-eye-fill v-else :alt="$t('seeOnScreen')" :title="$t('seeOnScreen')"
                                                @click="showOnTree(ind.indicatorName)" />
                                        </section>
                                    </section>
                                </section>
                            </section>
                            <span v-if="!isCreating" class="tip" style="text-align: center;"><strong>*</strong> {{
                                $t('drag-position-tree').toLowerCase() }}</span>
                        </section>
                        <section class="tree-content">
                            <section class="top-btn">
                                <input type="text" v-model="treeSearchName" id="filterTree"
                                    :placeholder="$t('indicator-filter')">
                                <button :title="$t('expand-tree')" @click="expandAll()">
                                    <b-icon-chevron-bar-expand :alt="$t('expand-tree')" />
                                </button>
                                <button :title="$t('collapse-tree')" @click="collapseAll()">
                                    <b-icon-chevron-bar-contract :alt="$t('collapse-tree')" />
                                </button>
                            </section>

                            <Tree ref="tree" :data="treeStructureList" :options="treeOptions" :filter="treeSearchName"
                                class="treeComponent">
                                <div slot-scope="{ node }" :id="`treeNode-${node.id}`" class="node-container"
                                    @dragenter="dragEnter($event, node)" @drop="onDrop($event, node)" @dragover.prevent
                                    @dragenter.prevent>
                                    <div class="node-text">{{ node != undefined && node.data != undefined &&
                                        node.data.model
                                        != undefined && node.data.model.indicatorName != undefined ?
                                        node.data.model.indicatorName : '' }}</div>
                                    <div v-if="node != undefined && node.data != undefined && node.data.model != undefined && node.data.model.indicatorRule != 'root' && node.data.model.indicatorRule != 'rootnode' && (!isCreating || node.data.model.indicatorName == newIndicator.indicatorName)"
                                        class="node-controls">
                                        <b-icon-x-circle @click.stop="openRemoveModal(node)" :title="$t('remover')" />
                                    </div>
                                </div>
                            </Tree>
                        </section>
                    </section>
                </b-tab>
                <b-tab class="screen-container" :disabled="!someScreensEdited" :title="$t('screenView')">
                    <section v-if="this.editedScreens != null && this.editedScreens.length > 0"
                        class="moved-indicators-context">
                        <CustomInput id="screenMovingIndicator" type="select" :title="$t('screens')"
                            :modelRef="this.selectedScreenId" :inputFunc="event => {
                                this.selectedScreenId = event.target.value
                            }" :optList="[...this.editedScreens]" optValue="" optDisplay="screenName" :useIdx="true" />

                        <span>{{ this.$t('not-positioned-ind') }}</span>
                        <section v-if="this.editedScreens != null && this.editedScreens.length > 0"
                            class="moved-indicators-list">
                            <section v-for="(inds, indIdx) in this.editedScreens[selectedScreenId].indicatorsMoved"
                                class="indicator-to-pos" :key="`indicators-${indIdx}-${inds.id}`" draggable="true"
                                @dragstart="moveIndicatorStart($event, inds)">
                                <p>{{ inds.data.model.indicatorName }}</p>
                                <section>
                                    <span>LI</span>
                                    <span>0,00</span>
                                    <span>LS</span>
                                </section>
                            </section>
                        </section>
                    </section>
                    <section class="screen-grid-matrix" v-if="this.editedScreens && this.editedScreens.length > 0">
                        <GridLayout ref="screenGridLayout" :layout="this.editedScreens[selectedScreenId].children"
                            :colNum="this.editedScreens[selectedScreenId].cols != null ? this.editedScreens[selectedScreenId].cols : 7"
                            :is-draggable="true" :is-resizable="false" :vertical-compact="true"
                            :preventCollision="false" :use-css-transforms="false" :margin="[4, 4]" :row-height="rowSize"
                            @layout-created="onGridCreated" group="grid" class="grid-container">
                            <GridItem v-for="(card, cardIdx) in this.editedScreens[selectedScreenId].children"
                                :x="card.x" :y="card.y" :w="card.w" :h="card.h" :i="card.i" :key="cardIdx"
                                :class="`grid-indicator ${card.added == true ? 'added-card' : ''}`"
                                :id="`cardItem-${card.indicatorId}`">
                                <section @drop.prevent="movedIndicatorDrop($event, card)"
                                    @dragleave.prevent="movedIndicatorLeave($event, card)"
                                    @dragover.prevent="movedIndicatorEnter($event, card)" class="card-content">
                                    <p>{{ card.indicatorName }}</p>
                                    <section v-if="rowSize > 30">
                                        <span>LI</span>
                                        <span>0,00</span>
                                        <span>LS</span>
                                    </section>
                                </section>
                            </GridItem>
                        </GridLayout>
                        <section class="add-cols">
                            <span>Colunas:</span>
                            <input type="number" :min="0" :value="this.editedScreens[selectedScreenId].cols"
                                @change="evt => this.editedScreens[selectedScreenId].cols = Number(evt.target.value)"
                                @keydown="() => { return false }" />
                        </section>
                    </section>
                </b-tab>
                <SaveButtons :isCreating="isCreating" :allowTab="allowTab"
                    :tabToEnable="showRefs == true ? 'collected' : 'abstract'"
                    :nextTabName="showRefs == true ? 'Referência Real' : 'Resumo'" :enableCommit="enableSave"
                    :saveFunc="applyAllConfigs" :clearFunc="clearChanges"
                    :creationToKeep="isCreating ? toSaveOnLocal : {}" />
            </b-tabs>

            <b-modal id="newScreenModal" :title="$t('create-screen-monitoring')" hide-footer>
                <section class="default-modal-inputs">
                    <CustomInput id="newScreenName" type="text" :title="$t('new-screen-name')"
                        :modelRef="this.newScreenStructure.newScreenName"
                        :inputFunc="event => this.newScreenStructure.newScreenName = event.target.value" :optList="[]"
                        optValue="" optDisplay="" :useIdx="false" />

                    <CustomInput id="newScreenAreaName" type="text" :title="$t('nome-da-area')"
                        :modelRef="this.newScreenStructure.newAreaName"
                        :inputFunc="event => this.newScreenStructure.newAreaName = event.target.value" :optList="[]"
                        optValue="" optDisplay="" :useIdx="false" />

                    <span class="tip"><strong>*</strong>{{ $t('para-criar-uma-tela-e-necessario-criar-uma-area-tambem')
                        }}</span>
                </section>

                <section class="default-modal-btn">
                    <img src="@/assets/salvar.png" :alt="$t('salvar')" :title="$t('salvar')" @click="saveNewScreen()" />
                    <img src="@/assets/sair.png" :alt="$t('sair')" :title="$t('sair')"
                        @click="$bvModal.hide('newScreenModal')" />
                </section>
            </b-modal>

            <b-modal id="newAreaModal" :title="$t('create-area-monitoring')" hide-footer>
                <section class="default-modal-inputs">
                    <CustomInput id="sreenSelected" type="select" :title="$t('select-monitoring-screen')"
                        :modelRef="this.newAreaStructure.screenId"
                        :inputFunc="event => this.newAreaStructure.screenId = event.target.value"
                        :optList="[...this.monitoringScreens]" optValue="screenIndicatorId" optDisplay="screenName"
                        :useIdx="false" />

                    <CustomInput id="newAreaName" type="text" :title="$t('nome-da-area')"
                        :modelRef="this.newAreaStructure.newAreaName"
                        :inputFunc="event => this.newAreaStructure.newAreaName = event.target.value" :optList="[]"
                        optValue="" optDisplay="" :useIdx="false" />
                </section>

                <section class="default-modal-btn">
                    <img src="@/assets/salvar.png" :alt="$t('salvar')" :title="$t('salvar')" @click="saveNewArea()" />
                    <img src="@/assets/sair.png" :alt="$t('sair')" :title="$t('sair')"
                        @click="$bvModal.hide('newAreaModal')" />
                </section>
            </b-modal>

            <b-modal id="editIndicator" :title="$t('generalChars')" hide-footer>
                <section class="default-modal-inputs">
                    <CustomInput id="indName" type="text" :title="$t('nome-do-indicador') + ':'"
                        :modelRef="this.editingIndicator.indicatorName"
                        :inputFunc="event => this.editingIndicator.indicatorName = event.target.value" :optList="[]"
                        :useIdx="false" />

                    <CustomInput id="indType" type="select" :title="$t('tipo-do-indicador') + ':'"
                        :modelRef="this.editingIndicator.calcType"
                        :inputFunc="event => this.editingIndicator.calcType = event.target.value"
                        :optList="[{ name: $t('online') }, { name: $t('analitico-normalized') }, { name: $t('sazonal') }, { name: $t('diario') }]"
                        optValue="name" optDisplay="name" :useIdx="false" />

                    <CustomInput id="indUnit" type="text" :title="$t('unit')" :modelRef="this.editingIndicator.unit"
                        :inputFunc="event => this.editingIndicator.unit = event.target.value" :optList="[]"
                        :useIdx="false" />
                </section>

                <section class="default-modal-btn">
                    <img src="@/assets/salvar.png" :alt="$t('salvar')" :title="$t('salvar')"
                        @click="saveGeneralInfos()" />
                    <img src="@/assets/sair.png" :alt="$t('sair')" :title="$t('sair')"
                        @click="$bvModal.hide('editIndicator')" />
                </section>
            </b-modal>

            <b-modal id="removeIndicator" :title="$t('remover-indicador')" ok-variant=danger :ok-title="$t('yes')"
                :cancel-title="$t('no')" @cancel="$bvModal.hide('editIndicator')" @ok="removeIndicatorFromTree">
                <p>Deseja remover o indicador <strong>{{ removingTreeNode.indicatorName }}</strong> da árvore?</p>
            </b-modal>
        </section>
    </section>
</template>
<script>
export default {
    name: 'GeneralConfigs',
    components: {
        SaveButtons, CustomInput, Tree,
        GridLayout: VueGridLayout.GridLayout,
        GridItem: VueGridLayout.GridItem,
        CustomLoading
    },
    props: {
        isCreating: Boolean,
        allowTab: Function,
        showRefs: Boolean
    },

    data() {
        return {
            someScreensEdited: false,
            enableSave: false,
            blockNewInput: false,
            creationMode: false,
            toSaveOnLocal: { type: 'generalConfig' },
            treeLocalJson: null,
            loadingSteps: { status: true, msg: 'Buscando Indicadores' },
            rowSize: 50,
            invalidPositions: [],
            rootNodeId: 1,
            monitoringIds: [],
            areasIds: [],
            monitoringScreens: [],
            editedScreens: [],
            selectedScreenId: 0,
            indicatorList: [],
            treeStructureList: {},
            indicatorsEditedList: [],
            indSearchName: ref(""),
            treeSearchName: ref(""),
            editingIndicator: { indicatorName: '', calcType: '', unit: '' },
            newIndicator: { indicatorName: '', calcType: '', unit: '' },
            newAreaStructure: { screenId: 0, newAreaName: '' },
            newScreenStructure: { newScreenName: '', newAreaName: '' },
            removingTreeNode: {},
            treeOptions: {
                filter: {
                    emptyText: "Sem resultados!",
                    showChildren: true,
                    plainList: false,
                    matcher(query, node) {
                        const escapedQuery = query.replace(/\([^)]*\)/g, '').replace(/[^a-zA-Z0-9\sáéíóúãõâêîôûçÁÉÍÓÚÃÕÂÊÎÔÛÇ]/g, '').trim();
                        return new RegExp(escapedQuery, 'i').test(node.data.text);
                    }
                },
                fetchData: this.getIndicatorTree(),
                dnd: false,
                parentSelect: false,
                multiple: false,
                keyboardNavigation: false,
            },
        }
    },

    computed: {
        movedIndsToWatch: function () {
            return this.editedScreens.length > 0 ? this.editedScreens[this.selectedScreenId].indicatorsMoved : null
        },
    },

    watch: {
        "indicatorsEditedList"() {
            let someScreenWasEdited = this.indicatorsEditedList.filter(item => item.onMonitoringScreen == true && item.isDeleted == false);

            if (this.indicatorsEditedList.length == 0) {
                this.enableSave = false;
                this.someScreensEdited = false;
            }
            else if (someScreenWasEdited.length > 0) {
                this.someScreensEdited = true;
                this.enableSave = false;
            } else {
                this.someScreensEdited = false;
                this.enableSave = true;
            }
        },

        "movedIndsToWatch"() {
            let someIndicatorRemaining = this.editedScreens.map(item => item.indicatorsMoved).flat();

            if (someIndicatorRemaining.length == 0) this.enableSave = true;
        },

        "selectedScreenId"() {
            this.fillEmptyScreen()
        },
    },

    methods: {
        filterList() {
            return this.indSearchName != '' && this.indSearchName != undefined ? this.indicatorList.filter(item => item.indicatorName.toLowerCase().includes(this.indSearchName.toLowerCase())) : this.indicatorList;
        },

        showOnTree(name) {
            this.treeSearchName = name;
        },

        indicatorToEdit(indicator) {
            let calcFormatted = indicator.calcType[0].toUpperCase() + indicator.calcType.slice(1);
            indicator.calcType = calcFormatted;
            this.editingIndicator = { ...indicator };
            this.$bvModal.show('editIndicator')
        },

        openRemoveModal(node) {
            this.removingTreeNode = node;
            this.$bvModal.show('removeIndicator');
        },

        expandAll() {
            this.$refs.tree.findAll((el, idx) => idx != 0 ? el.expand() : el)
        },

        collapseAll() {
            this.$refs.tree.findAll((el, idx) => idx != 0 ? el.collapse() : el)
        },

        startDrag(evt, ind) {
            evt.dataTransfer.dropEffect = 'move'
            evt.dataTransfer.effectAllowed = 'move'
            evt.dataTransfer.setData('indInfo', JSON.stringify(ind))
        },

        dragEnter(_, node) {
            let hoverNode = this.$refs.tree.find(item => item.id == node.id);

            hoverNode.expand();
            hoverNode.select();
        },

        onDrop(evt, node) {
            let ind = evt.dataTransfer.getData('indInfo')
            if (!ind) return;

            if (this.invalidPositions.includes(node.data.model.indicatorId)) {
                MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Posição Inválida', 'Posicione o indicador dentro de algum root ou abaixo de outro indicador.');
                return;
            }

            let dadRoot = node.data.model.indicatorRule.includes("root") ? node : node.parent;

            let indJson = JSON.parse(ind)

            if (this.isCreating == true) {
                indJson.indicatorId = `new-${this.newIndicator.indicatorName}`;
                indJson.sequence = node.data.model.treeSequence;
                this.blockNewInput = true
            }

            let nodeSelected = this.$refs.tree.findAll(item => item.data.model.indicatorId == indJson.indicatorId)

            let jsonTree = this.$refs.tree.toJSON();
            let maxId = this.findMaxId(jsonTree);

            let nodeLevel = node.data.model.indicatorRule.includes("root") ? node.data.model.treeLevel + 1 : node.data.model.treeLevel;
            let newNodeParent = node.data.model.indicatorRule.includes("root") ? node : dadRoot

            let movedToScreen = this.checkMonitoringScreen(node, dadRoot);

            let area = null;

            if (movedToScreen != null) {
                area = this.checkArea(node, dadRoot);
            }

            for (let selected of nodeSelected) {
                if (dadRoot && dadRoot.children && dadRoot.children.includes(selected) ||
                    (node && node.children && node.children.includes(selected))) {
                    MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Já Posicionado', 'O indicador já está posicionado nessa tela/root.');
                    return;
                }

                if (movedToScreen != null) {
                    let screensChild = movedToScreen.children.map(item => [...item.children]).flat();
                    screensChild.push(movedToScreen.children);

                    if (screensChild.includes(selected)) {
                        MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Já Posicionado', 'O indicador já está posicionado nessa tela/root.');
                        return;
                    }
                }

            }

            let newNode = {
                indicatorId: maxId + 1,
                text: indJson.indicatorName,
                data: { model: { ...indJson, id: maxId + 1, treeLevel: nodeLevel, treeSequence: node.data.model.treeSequence }, text: indJson.indicatorName },
                children: [],
                state: {},
                parent: newNodeParent
            }

            if (node.data.model.indicatorRule.includes("root")) {
                node.prepend(newNode);
            } else {
                node.after(newNode);
            }

            this.treeStructureList = this.$refs.tree.toJSON();

            let monitoringScreenId = movedToScreen != null ? movedToScreen.data.model.indicatorId : null

            if (movedToScreen != null) {
                area = this.checkArea(node, dadRoot);

                let idFound = MediatorIndicatorEditor.screenPositionsList.find(item => item.screenIndicatorId == monitoringScreenId);

                if (idFound != undefined) monitoringScreenId = idFound.gridIndicatorId
            }

            let editionRegisterToBack = {
                indicatorId: indJson.indicatorId,
                isDeleted: false,
                onMonitoringScreen: movedToScreen != null ? true : false,
                screenId: monitoringScreenId,
                screenName: movedToScreen != null ? movedToScreen.data.model.indicatorName : "",
                areaName: movedToScreen != null && area != null ? area.data.model.indicatorName : "",
                level: nodeLevel,
                sequence: node.data.model.treeSequence,
                cardX: indJson.cardXPosition,
                cardY: indJson.cardYPosition,
            }

            this.indicatorsEditedList.push(editionRegisterToBack);

            if (movedToScreen != null) {
                let foundOnScreen = MediatorIndicatorEditor.screenPositionsList.find(item => item.screenIndicatorId == movedToScreen.data.model.indicatorId);

                if (foundOnScreen == undefined) {
                    foundOnScreen = {
                        cardsinScreen: [],
                        cols: 7
                    }
                }

                let screenAlreadyAdded = this.editedScreens.findIndex(item => item.id == movedToScreen.data.model.indicatorId);

                let allChildrens = foundOnScreen.cardsinScreen.map(item => {
                    return {
                        indicatorName: item.nameOfIndicator,
                        indicatorId: item.cardConfigurationStats.indicatorId,
                        x: item.cardConfigurationStats.cardXPosition,
                        y: item.cardConfigurationStats.cardYPosition,
                        h: item.cardConfigurationStats.cardHeight,
                        w: item.cardConfigurationStats.cardWidth,
                        i: item.cardConfigurationStats.indicatorId,
                        added: false,
                    }
                });

                if (screenAlreadyAdded == -1 || screenAlreadyAdded == null || screenAlreadyAdded == undefined) {
                    this.editedScreens.push({ id: movedToScreen.data.model.indicatorId, cols: foundOnScreen.cols > 0 ? foundOnScreen.cols : 7, minCols: foundOnScreen.cols > 0 ? foundOnScreen.cols : 7, screenName: movedToScreen.data.model.indicatorName, screen: movedToScreen, children: allChildrens, indicatorsMoved: [newNode] });
                } else {
                    let foundOnMoved = this.editedScreens[screenAlreadyAdded].indicatorsMoved.findIndex(item => item.data.model.indicatorId == newNode.data.model.indicatorId || item.indicatorId == newNode.indicatorId)
                    if (foundOnMoved == -1) {
                        this.editedScreens[screenAlreadyAdded].indicatorsMoved.push(newNode)
                    } else {
                        this.editedScreens[screenAlreadyAdded].indicatorsMoved[foundOnMoved] = newNode;
                    }

                    this.editedScreens[screenAlreadyAdded].children = this.editedScreens[screenAlreadyAdded].children.length > 0 ? this.editedScreens[screenAlreadyAdded].children : allChildrens;
                    this.editedScreens[screenAlreadyAdded].cols = foundOnScreen.cols > 0 ? foundOnScreen.cols : 7;
                    this.editedScreens[screenAlreadyAdded].minCols = foundOnScreen.cols > 0 ? foundOnScreen.cols : 7;
                }
            }

            if (this.creationMode) {
                this.updateStorage()
            }
        },

        moveIndicatorStart(event, ind) {
            event.dataTransfer.dropEffect = 'move'
            event.dataTransfer.effectAllowed = 'move'
            event.dataTransfer.setData('movedIndicator', JSON.stringify(ind.data.model))
        },

        movedIndicatorEnter(_, node) {
            let nodeId = `cardItem-${node.indicatorId}`;

            let enteredNode = document.getElementById(nodeId);

            if (enteredNode) {
                enteredNode.style.backgroundColor = "green"
            }
        },

        movedIndicatorLeave(_, node) {
            let nodeId = `cardItem-${node.indicatorId}`;

            let enteredNode = document.getElementById(nodeId);
            let wasAdded = enteredNode.className.includes('added-card')

            if (enteredNode) {
                if (wasAdded) {
                    enteredNode.style.backgroundColor = "#00A39F"
                } else {
                    enteredNode.style.backgroundColor = "#000000"
                }
            }
        },

        movedIndicatorDrop(event, node) {
            let nodeId = `cardItem-${node.indicatorId}`;

            let enteredNode = document.getElementById(nodeId);

            let ind = event.dataTransfer.getData('movedIndicator');
            let indJson = JSON.parse(ind)

            let foundItem = this.editedScreens[this.selectedScreenId].children.filter(item => item.indicatorId == indJson.indicatorId);

            let foundOnTree = this.treeStructureList.find(item => item.data.model.indicatorId == indJson.indicatorId);

            let wasAdded = enteredNode.className.includes('added-card')

            if (foundItem.length > 0 && foundOnTree) {
                if (enteredNode) {
                    if (wasAdded) {
                        enteredNode.style.backgroundColor = "#00A39F"
                    } else {
                        enteredNode.style.backgroundColor = "#000000"
                    }
                }
                showError(this.$t('indicator-already-on-screen'));
                return;
            }


            if (enteredNode) {
                if (wasAdded) {
                    enteredNode.style.backgroundColor = "#00A39F"
                } else {
                    enteredNode.style.backgroundColor = "#000000"
                }
            }

            if (this.editedScreens[this.selectedScreenId].children.length == 0) {
                indJson.x = 0
                indJson.y = 0
                indJson.cardXPosition = 1
                indJson.cardYPosition = 1
                indJson.added = true;
            } else {
                indJson.x = node.x
                indJson.y = node.y
                indJson.cardXPosition = node.x
                indJson.cardYPosition = node.y
                indJson.added = true;
            }

            if (this.isCreating == true) indJson.i = ""

            this.$refs.screenGridLayout.dragEvent('dragend', 'drop', indJson.x, indJson.y, 1, 1);
            this.editedScreens[this.selectedScreenId].children = this.editedScreens[this.selectedScreenId].children.filter(obj => obj.i !== 'drop');

            this.editedScreens[this.selectedScreenId].children.push({
                ...indJson,
                x: indJson.x,
                y: indJson.y,
                w: 1,
                h: 1,
                i: indJson.indicatorId
            });


            this.$refs.screenGridLayout.dragEvent('dragend', indJson.i, indJson.x, indJson.y, 1, 1);

            this.editedScreens[this.selectedScreenId].indicatorsMoved = this.editedScreens[this.selectedScreenId].indicatorsMoved.filter(item => item.data.model.indicatorId != indJson.indicatorId)

            if (this.creationMode) {
                this.updateStorage()
            }
        },

        findMaxId(items) {
            let maxId = -Infinity;

            items.forEach(item => {
                if (item.data && item.data.model && item.data.model.id > maxId) {
                    maxId = item.data.model.id;
                }

                if (item.children) {
                    maxId = Math.max(maxId, this.findMaxId(item.children));
                }
            });

            return maxId;
        },

        removeIndicatorFromTree() {
            let dadRoot = this.removingTreeNode.parent;

            let movedToScreen = this.checkMonitoringScreen(this.removingTreeNode, dadRoot)

            let area = null;
            let monitoringScreenId = movedToScreen != null ? movedToScreen.data.model.indicatorId : null

            if (movedToScreen != null) {
                area = this.checkArea(this.removingTreeNode, dadRoot);

                let idFound = MediatorIndicatorEditor.screenPositionsList.find(item => item.screenIndicatorId == monitoringScreenId);

                if (idFound != undefined) monitoringScreenId = idFound.gridIndicatorId
            }

            let deletedIndicatorObject = {
                indicatorId: this.removingTreeNode.data.model.indicatorId,
                isDeleted: true,
                onMonitoringScreen: movedToScreen != null ? true : false,
                level: this.removingTreeNode.data.model.treeLevel,
                sequence: this.removingTreeNode.data.model.treeSequence == undefined ? this.removingTreeNode.data.model.sequence : this.removingTreeNode.data.model.treeSequence,
                screenId: monitoringScreenId,
                screenName: movedToScreen != null ? movedToScreen.data.model.indicatorName : "",
                areaName: movedToScreen != null && area != null ? area.data.model.indicatorName : "",
                cardX: 0,
                cardY: 0,
            }

            if (movedToScreen != null) {
                let foundOnScreen = MediatorIndicatorEditor.screenPositionsList.findIndex(item => item.screenIndicatorId == movedToScreen.data.model.indicatorId);

                if (foundOnScreen != undefined && foundOnScreen != -1) {
                    MediatorIndicatorEditor.screenPositionsList[foundOnScreen].cardsinScreen = MediatorIndicatorEditor.screenPositionsList[foundOnScreen].cardsinScreen
                        .filter(item => item.cardConfigurationStats.indicatorId != deletedIndicatorObject.indicatorId)

                    let foundInsideComponent = this.editedScreens.findIndex(item => item.id == MediatorIndicatorEditor.screenPositionsList[foundOnScreen].screenIndicatorId)

                    if (foundInsideComponent != undefined && foundInsideComponent != -1) {
                        this.editedScreens[foundInsideComponent].children = this.editedScreens[foundInsideComponent].children.filter(item => item.indicatorId != deletedIndicatorObject.indicatorId)

                        this.editedScreens[foundInsideComponent].indicatorsMoved = this.editedScreens[foundInsideComponent].indicatorsMoved.filter(item => item.data.model.indicatorId != deletedIndicatorObject.indicatorId)

                        // if (this.editedScreens[foundInsideComponent].indicatorsMoved.length == 0) {
                        //     this.editedScreens.splice(foundInsideComponent, 1)
                        // }

                    }
                }
            }

            this.$refs.tree.remove(this.removingTreeNode, false);
            this.treeStructureList = this.$refs.tree.toJSON();


            if (this.creationMode) {
                let foundInd = this.$refs.tree.find(node => node.data.model.indicatorId == deletedIndicatorObject.indicatorId);
                if (foundInd.length == 0) this.blockNewInput = false;
            }

            let idxFound = this.indicatorsEditedList.findIndex(item => item.indicatorId == deletedIndicatorObject.indicatorId && item.screenId == deletedIndicatorObject.screenId)

            if (idxFound != -1) {
                this.indicatorsEditedList.splice(idxFound, 1)
            } else {
                this.indicatorsEditedList.push(deletedIndicatorObject);
            }

            if (this.creationMode) {
                this.updateStorage()
            }
        },

        findIdsInsideChildrens(items) {
            let itensFound = [];

            items.forEach(item => {
                if (item.data && item.data.model) {
                    itensFound.push(item.data.model);
                }

                if (item.children) {
                    itensFound = itensFound.concat(this.findIdsInsideChildrens(item.children));
                }
            });

            return itensFound;
        },

        checkMonitoringScreen(node, dadRoot) {
            if (dadRoot == undefined || dadRoot == null) return null;
            try {
                if (this.monitoringIds.includes(node.data.model.indicatorId)) {
                    return node;
                } else if (dadRoot && this.monitoringIds.includes(dadRoot.data.model.indicatorId)) {
                    return dadRoot;
                } else if (dadRoot.parent && this.monitoringIds.includes(dadRoot.parent.data.model.indicatorId)) {
                    return dadRoot.parent;
                } else if (dadRoot.parent.parent && this.monitoringIds.includes(dadRoot.parent.parent.data.model.indicatorId)) {
                    return dadRoot.parent.parent;
                } else if (dadRoot.parent.parent.parent && this.monitoringIds.includes(dadRoot.parent.parent.parent.data.model.indicatorId)) {
                    return dadRoot.parent.parent.parent;
                }
            } catch {
                return null
            }

            return null
        },

        checkArea(node, dadRoot) {
            if (dadRoot == undefined || dadRoot == null) return null;

            try {
                if (this.areasIds.includes(node.data.model.indicatorId)) {
                    return node;
                } else if (dadRoot && this.areasIds.includes(dadRoot.data.model.indicatorId)) {
                    return dadRoot;
                } else if (dadRoot.parent && this.areasIds.includes(dadRoot.parent.data.model.indicatorId)) {
                    return dadRoot.parent;
                } else if (dadRoot.parent.parent && this.areasIds.includes(dadRoot.parent.parent.data.model.indicatorId)) {
                    return dadRoot.parent.parent;
                } else if (dadRoot.parent.parent.parent && this.areasIds.includes(dadRoot.parent.parent.parent.data.model.indicatorId)) {
                    return dadRoot.parent.parent.parent;
                }
            } catch {
                return null

            }


            return null
        },

        onGridCreated() {
            this.fillEmptyScreen()
        },

        fillEmptyScreen() {
            if (this.editedScreens[this.selectedScreenId].children.length == 0 && this.editedScreens[this.selectedScreenId].indicatorsMoved.length > 0) {

                let cards = this.editedScreens[this.selectedScreenId].indicatorsMoved.map((item, idx) => {
                    return {
                        ...item.data.model,
                        x: 0,
                        y: idx,
                        h: 1,
                        w: 1,
                        i: item.data.model.indicatorId,
                        added: true,
                    }
                })

                this.editedScreens[this.selectedScreenId].indicatorsMoved = [];
                this.editedScreens[this.selectedScreenId].children = cards;

                if (this.creationMode) {
                    this.updateStorage()
                }
            }
        },

        resizeCard() {
            let newSize = Math.floor((window.innerHeight / 10) - 45);
            this.rowSize = newSize < 30 ? 30 : newSize;
        },

        updateStorage() {
            this.toSaveOnLocal.indicatorInfo = this.newIndicator;
            this.toSaveOnLocal.positionsOnTree = this.indicatorsEditedList;
            this.toSaveOnLocal.jsonTree = this.treeStructureList;
            this.toSaveOnLocal.screensToPosition = this.editedScreens;
            this.toSaveOnLocal.blockStatus = this.blockNewInput;

            MediatorIndicatorEditor.generalConfig = this.toSaveOnLocal;
        },

        async clearChanges() {
            this.loadingSteps.status = true;
            this.loadingSteps.msg = 'Recarregando Dados';
            this.indicatorList = [];
            this.treeStructureList = {}
            this.indicatorsEditedList = [];
            this.editedScreens = [];
            this.newScreenStructure = { newScreenName: '', newAreaName: '' }
            this.newAreaStructure = { screenId: '', newAreaName: '' };
            this.selectedScreenId = 0;
            this.someScreensEdited = false;
            this.indSearchName = ref("");
            this.treeSearchName = ref("");
            await MediatorIndicatorEditor.init();
            await this.getIndicatorTree();
            this.indicatorList = MediatorIndicatorEditor.indicatorsList;
            this.enableSave = false;
            this.loadingSteps.status = false;
        },

        async getIndicatorTree() {
            this.loadingSteps = { status: true, msg: 'Construindo Árvore' }

            if ((!this.treeStructureList || Object.keys(this.treeStructureList).length == 0)) {
                await axios
                    .get(`${urlMainAPI}/getIndicatorEditorTreeComplete`)
                    .then(async (res) => {
                        if (res.status == 200 && res.data != null) {
                            if (this.isCreating == true && this.treeLocalJson != null && this.treeLocalJson != undefined) {
                                this.treeStructureList = this.treeLocalJson[0]
                            } else {
                                this.treeStructureList = res.data;
                            }
                        }
                    })
                    .catch(err => {
                        showError(this.$t('falha-ao-carregar-os-dados'))
                        console.error(err)
                    });

                if (this.$refs.tree) {
                    this.$refs.tree.setModel(this.treeStructureList)
                }

                this.invalidPositions.push(this.treeStructureList.data.model.indicatorId);


                let rootsIds = this.treeStructureList.children.map(item => item.data.model.indicatorId);
                this.invalidPositions.push(...rootsIds);

                let foundRootNode = this.$refs.tree.findAll(item => item.data.model.indicatorRule == 'rootnode').map(item => item.data.model.indicatorId)
                let foundScreens = this.$refs.tree.findAll(item => item.data.model.indicatorName.toLowerCase().startsWith(this.$t('screen').toLowerCase()) || item.data.model.indicatorName.toLowerCase().startsWith(this.$t('screens').toLowerCase()))
                let groupArr = this.$refs.tree.findAll(item => item.data.model.indicatorName.toLowerCase().startsWith(this.$t('monitoringScreemSingular').toLowerCase()) || item.data.model.indicatorName.toLowerCase().startsWith(this.$t('monitoringScreemPlural').toLowerCase()));
                let foundScreensGroup = groupArr.map(item => item.data.model.indicatorId)
                let screensGroupArr = Array.from(foundScreens)

                if (groupArr.length > 0) {
                    for (let item of groupArr[0].children) {
                        let alteradyOnList = screensGroupArr.filter(area => area.id == item.id)

                        if (alteradyOnList.length == 0 || alteradyOnList == undefined) screensGroupArr.push(item)
                    }
                }

                this.invalidPositions.push(...foundScreensGroup);
                this.invalidPositions.push(...foundRootNode);

                if (screensGroupArr.length > 0) {
                    let screens = screensGroupArr.map(item => {
                        return {
                            screenTreeId: item.data.model.id,
                            screenIndicatorId: item.data.model.indicatorId,
                            screenName: item.data.model.indicatorName,
                            screenLevel: item.data.model.treeLevel,
                            screenSequence: item.data.model.treeSequence,
                            screenChildrens: item.children
                        }
                    });

                    let areasIds = screens.map(item => {
                        let foundIds = [];
                        if (item.screenChildrens.length > 0) {
                            foundIds = item.screenChildrens.map(area => area.data.model.indicatorId)
                        }
                        return foundIds
                    }).flat();

                    let screensIds = screens.map(item => item.screenIndicatorId);

                    this.invalidPositions.push(...screensIds);
                    this.monitoringScreens = screens.filter(item => !item.screenName.toLowerCase().startsWith(this.$t('monitoringScreemSingular').toLowerCase()) && !item.screenName.toLowerCase().startsWith(this.$t('monitoringScreemPlural').toLowerCase()));
                    this.monitoringIds = [...screensIds];
                    this.areasIds = [...areasIds];
                }



                this.loadingSteps.msg = 'Buscando Telas de Monitoramento'
            }

            if (MediatorIndicatorEditor.screenPositionsList.length == 0) {
                await MediatorIndicatorEditor.getScreenPositionList();
            }

            this.loadingSteps.status = false;
        },

        async saveGeneralInfos() {
            let validaFields = MediatorIndicatorEditor.validateFields(this.editingIndicator, ['indicatorName', 'calcType', 'unit'], ['', undefined])
            if (validaFields == false) {
                MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Campos Vazios', 'Preencha todos os campos antes de salvar.');
                return;
            }

            this.$bvModal.hide('editIndicator');

            this.loadingSteps.status = true;
            this.loadingSteps.msg = 'Armazenando Informações';

            let cleanUnit = this.editingIndicator.unit.replaceAll('(', '').replaceAll(')', '')
            let formatedName = this.editingIndicator.indicatorName;

            let unitParenteses = this.editingIndicator.indicatorName.match(/\(([^()]+)\)/g);

            if (unitParenteses != undefined && unitParenteses != null && unitParenteses.length > 0) {
                formatedName = this.editingIndicator.indicatorName.replace(unitParenteses[unitParenteses.length - 1], '').trim();
            }

            if (formatedName.trim() == '' || cleanUnit.trim() == '') {
                MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Campos Vazios', 'Preencha o nome do indicador e a unidade de medida antes de salvar.');
                return;
            }

            let editedIndicator = {
                Indicatorid: this.editingIndicator.indicatorId,
                IndicatorName: `${formatedName} (${cleanUnit})`,
                CaclType: this.editingIndicator.calcType.toLowerCase()
            }

            await axios.post(`${urlMainAPI}/saveIndicatorDetails`, editedIndicator)
                .then(async (res) => {
                    if (res.status == 200) {
                        defaultSuccess(this.$t('general-info-update'));
                    }
                }).catch(err => {
                    showError(this.$t('falha-ao-salvar'));
                    console.error(err)
                }).finally(async () => {
                    await this.clearChanges();
                })

            this.loadingSteps.status = false;

        },

        async saveNewArea() {
            let validaFields = MediatorIndicatorEditor.validateFields(this.newAreaStructure, ['newAreaName', 'screenId'], ['', undefined])
            if (validaFields == false) {
                MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Campos Vazios', 'Preencha todos os campos antes de salvar.');
                return;
            }

            this.$bvModal.hide('newAreaModal');

            this.loadingSteps.status = true;
            this.loadingSteps.msg = 'Armazenando Informações';

            let screen = this.monitoringScreens.find(item => item.screenIndicatorId == this.newAreaStructure.screenId);

            let lastAreaOnScreen = screen.screenChildrens[screen.screenChildrens.length - 1];
            let lastIndicatorOnLastScreen = lastAreaOnScreen.children == undefined || lastAreaOnScreen.children.length <= 0 ? lastAreaOnScreen : lastAreaOnScreen.children[lastAreaOnScreen.children.length - 1];

            let newAreaObj = {
                gridId: screen.screenIndicatorId,
                gridLevel: lastAreaOnScreen.screenLevel,
                gridSequence: screen.screenSequence,
                newAreaName: this.newAreaStructure.newAreaName,
                newAreaLevel: lastAreaOnScreen.data.model.treeLevel,
                newAreaSequence: lastIndicatorOnLastScreen.data.model.treeSequence + 1
            }

            await axios.post(`${urlMainAPI}/saveAreaIndicatorEditor`, newAreaObj)
                .then(async (res) => {
                    if (res.status == 200) {
                        defaultSuccess(this.$t('newAreaSuccess'))
                    }
                }).catch(err => {
                    console.error(err);
                    showError(this.$t('newAreaError'))
                }).finally(async () => {
                    await this.clearChanges();
                })

            this.loadingSteps.status = false;

        },

        async saveNewScreen() {
            let validaFields = MediatorIndicatorEditor.validateFields(this.newScreenStructure, ['newScreenName', 'newAreaName'], ['', undefined])

            if (validaFields == false) {
                MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Campos Vazios', 'Preencha todos os campos antes de salvar.');
                return;
            }

            this.$bvModal.hide('newScreenModal');

            this.loadingSteps.status = true;
            this.loadingSteps.msg = 'Armazenando Informações';

            let lastScreen = this.monitoringScreens[this.monitoringScreens.length - 1];
            let lastarea = lastScreen.screenChildrens[lastScreen.screenChildrens.length - 1];
            let allChildren = this.findIdsInsideChildrens(lastarea.children)
            let lastIndicator = allChildren.length > 0 ? allChildren[allChildren.length - 1] : lastarea.data.model;

            let newScreenObj = {
                newGridName: this.newScreenStructure.newScreenName,
                newGridLevel: lastScreen.screenLevel,
                newGridSequence: lastIndicator.treeSequence + 1,
                newAreaName: this.newScreenStructure.newAreaName,
                newAreaLevel: lastScreen.screenLevel + 1,
                newAreaSequence: lastIndicator.treeSequence + 2
            }

            await axios.post(`${urlMainAPI}/saveScreenIndicatorEditor`, newScreenObj)
                .then(async (res) => {
                    if (res.status == 200) {
                        defaultSuccess(this.$t('newScreenSuccess'))
                    }
                }).catch(err => {
                    console.error(err);
                    showError(this.$t('newScreenError'))
                }).finally(async () => {
                    await this.clearChanges();
                })

            this.loadingSteps.status = false;
        },

        async applyAllConfigs() {
            if (this.indicatorsEditedList.length == 0) {
                MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Sem Modificações', 'Não existem modificações para salvar.');
                return;
            }


            this.loadingSteps.msg = 'Armazenando Informações';
            this.loadingSteps.status = true;


            let screensList = [];

            if (this.editedScreens.length > 0) {
                screensList = this.editedScreens.map(item => {
                    return {
                        gridId: item.screen.data.model.indicatorId,
                        gridName: item.screen.data.model.indicatorName,
                        cols: item.cols,
                        indicatorsInScreens: item.children.map(child => {
                            return {
                                idIndicator: child.i,
                                cardX: child.x,
                                cardY: child.y,
                            }
                        })
                    }
                });
            }

            let fullConfigObj = {
                indicatorsModified: this.indicatorsEditedList.flat().sort((a, b) => b.isDeleted - a.isDeleted),
                screensModified: screensList
            }

            await axios.post(`${urlMainAPI}/saveGeneralConfigurationIndicatorsByEditor`, fullConfigObj)
                .then(async (res) => {
                    if (res.status == 200) {
                        defaultSuccess('Alterações salvas com sucesso!')
                    }
                }).catch(err => {
                    console.error(err);
                    showError('Falha ao salvar.')
                }).finally(async () => {
                    await this.clearChanges();
                });

            this.loadingSteps.status = false;
        },
    },

    async mounted() {
        this.indicatorList = MediatorIndicatorEditor.indicatorsList;
        window.addEventListener('resize', this.resizeCard);


        if (this.creationMode) {
            this.loadingSteps = { status: true, msg: 'Buscando Indicadores' }
            let localJSON = MediatorIndicatorEditor.generalConfig

            if (localJSON != null && localJSON != undefined && Object.keys(localJSON).length != 0 && Object.keys(localJSON).length > 1) {
                this.treeLocalJson = localJSON.jsonTree;
                this.newIndicator = localJSON.indicatorInfo;
                this.blockNewInput = localJSON.blockStatus;

                this.indicatorsEditedList = localJSON.positionsOnTree;
                this.editedScreens = localJSON.screensToPosition;

                this.toSaveOnLocal = MediatorIndicatorEditor.generalConfig;
            }


            if ((this.treeStructureList && Object.keys(this.treeStructureList).length != 0)) {
                this.loadingSteps = { status: false, msg: 'Construindo Árvore' }
            }

        }

        if (this.indicatorList.length > 0 && MediatorIndicatorEditor.screenPositionsList.length > 0) {
            this.loadingSteps.status = false;
        }

        await MediatorIndicatorEditor.getCollectorBases();
        await MediatorIndicatorEditor.generateMapObj();
        await MediatorIndicatorEditor.getProductionPlanData();
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.resizeCard);
    },

    async created() {
        this.loadingSteps.msg = 'Buscando Indicadores'
        this.indicatorList = MediatorIndicatorEditor.indicatorsList;

        this.creationMode = this.isCreating;
        this.allowTabFunc = this.allowTab;

        this.resizeCard();
    }
}
</script>
<style scoped>
@import '../commons/commonStyles.css';

.general-configs-container {
    padding-top: 0.5rem;
    position: relative;
}

.tree-view-container {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-template-rows: 1fr;
    grid-column-gap: 0.5rem;
    grid-row-gap: 0px;
    padding: 1rem;
}

.tree-container,
.screen-container {
    border: 1px solid #FF5F00;
    border-radius: 0.2rem;
    margin-bottom: 0.5rem;
}

.new-roots-btn {
    display: flex;
    column-gap: 1rem;
    margin-bottom: 0.2rem;
}

.new-roots-btn button {
    background-color: #FF5F00;
    color: white;
    border: none;
    border-radius: 0.2rem;
    width: 100%;
    padding: 0.4rem 0;
    font-size: 1rem;
    font-weight: 600;
}

.indicator-list-content {
    display: flex;
    flex-direction: column;
    row-gap: 0.5rem;
    padding-right: 1rem;
    border-right: 1px solid rgba(0, 0, 0, 0.125);
}

#filterList {
    padding: 0.2rem 0.5rem;
    width: 100%;
    margin-bottom: 0.5rem;
}

.listed-indicators {
    height: 13.3rem;
    overflow-y: auto;
}

.indicator {
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f1fdfc;
    border-bottom: 1px solid #00A39F;
    margin: 0.5rem 0;
    cursor: move;
    padding: 0.5rem;
}

.ind-btn {
    display: flex;
    align-items: center;
    column-gap: 1rem;
}

.ind-btn svg {
    cursor: pointer;
    color: #00A39F;
    font-size: 1.2rem;
}

.tip {
    font-size: 0.8rem;
    color: #7E7E7E;
}

.tip strong {
    color: #FF5F00;
}

.top-btn {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    column-gap: 0.5rem;
}

#filterTree {
    width: 100%;
    padding: 0.35rem 0.5rem;
}


.top-btn button {
    cursor: pointer;
    background-color: transparent;
    border: 1px solid #FF5F00;
    border-radius: 0.2rem;
    padding: 0.35rem 0.8rem;
    vertical-align: middle;
    text-align: center;
}

.top-btn button svg {
    font-size: 1.3rem;
    color: #FF5F00;
}

.default-modal-inputs {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    row-gap: 0.8rem;
    width: 100%;
}

.default-modal-btn {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    column-gap: 0.8rem;
    margin-top: 1rem;
}

.default-modal-btn img {
    width: 32px;
    cursor: pointer;
}

.new-indicator-inputs section section {
    display: flex;
    column-gap: 0.8rem;
}

.new-indicator-inputs section section label:last-child {
    width: 30%;
}

.new-indicator-tip {
    font-size: 0.9rem;
    color: #C5C5C5;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 0.5rem;
}

.new-indicator-tip::before {
    content: '';
    display: block;
    background-color: #0000001e;
    width: 100px;
    height: 1px;
}

.new-indicator-tip::after {
    content: '';
    display: block;
    background-color: #0000001e;
    width: 100px;
    height: 1px;
}

.new-indicator-draggable {
    user-select: none;
    margin-left: auto;
    margin-right: auto;
    cursor: move;

    width: max-content;
    background-color: #f1fdfc;
    border: 1px dashed #00A39F;
    color: #00A39F;
    font-weight: 600;
    border-radius: 5rem;

    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0.8rem;

    column-gap: 1rem;
}

.new-indicator-draggable span {
    overflow: hidden;
    max-width: 15rem;
    text-overflow: ellipsis;
    width: fit-content;
    text-wrap: nowrap;
}

.new-indicator-circle {
    width: 0.8rem;
    height: 0.8rem;
    background-color: #00A39F;
    border-radius: 100%;
}

.new-indicator-icon {
    color: #00A39F;
    font-weight: 800;
}

.draggable-unactive {
    cursor: not-allowed;
    background-color: #FAFAFA;
    border-color: #C3C3C3;
    color: #C3C3C3;
}

.draggable-unactive .new-indicator-circle {
    background-color: #C3C3C3;
}

.draggable-unactive .new-indicator-icon {
    color: #C3C3C3;
}

.tree-content {
    width: 100% !important;
    display: flex;
    flex-direction: column;
    height: 19.5rem;
    overflow-y: auto;
}

.treeComponent {
    width: 100%;
    margin: 0.8rem 0;
}

.node-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-right: 2rem;
    position: relative;
}

.node-container::after {
    content: "";
    width: 100%;
    height: 2px;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: #00A39F;
    display: none;
}

.node-controls svg {
    cursor: pointer;
    color: red;
    font-weight: 600;
    font-size: 1.2rem;
}

.screen-container {
    display: flex;
    width: 100%;
    justify-content: space-between;
}

.moved-indicators-context {
    width: max-content;
    padding-right: 1rem;
    padding-left: 0.5rem;
}

.moved-indicators-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    row-gap: 0.8rem;
    padding-top: 0.3rem;
    overflow-y: auto;
    height: 17rem;
}


.screen-grid-matrix {
    width: 100%;
    position: relative;
}

.indicator-to-pos {
    background-color: #00A39F;
    color: #fff;
    border-radius: 0.3rem;
    cursor: move;

    width: 95%;
    height: max-content;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    font-size: 1rem;
    padding: 0.5rem;
    border: 1px solid black;
}

.indicator-to-pos p {
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 13rem;
    text-wrap: nowrap;
    padding-bottom: 0.3rem;
}

.indicator-to-pos section {
    font-size: 0.7rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 90%;
    height: min-content;
}

.grid-container {
    padding: 0.3rem;
}

.grid-indicator {
    background-color: black;
    border-radius: 0.3rem;
    color: #fff;
    touch-action: none;

    cursor: move;
    user-select: none;
}

.grid-indicator section {
    height: 100%;
    width: 100%;
}

.card-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 0.8rem;
}

.card-content p {
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 8rem;
    text-wrap: nowrap;
}

.card-content section {
    font-size: 0.6rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 90%;
    padding-bottom: 0.2rem;
    height: min-content;

}

.tabs-container {
    max-height: 57vh;
}

.added-card {
    background-color: #00A39F;
}

.add-cols {
    position: absolute;
    bottom: -50px;
    left: -295px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.add-cols span {
    font-size: 0.9rem;
    font-weight: 500;
}

.add-cols input {
    width: 6rem;
}

.seeNewInd {
    cursor: pointer;
}

.blockInput {
    pointer-events: none !important;
    filter: grayscale(1) !important;
}


@media (min-height: 900px) {
    .listed-indicators {
        height: 26rem;
    }

    .tree-content {
        height: 33rem;
    }

    .card-content p {
        font-size: 1rem;
        max-width: 13rem;
    }

    .card-content section {
        font-size: 0.8rem;
    }

    .tabs-container {
        max-height: 77vh;
    }

    .moved-indicators-list {
        height: 26rem;
    }
}
</style>
